exports.components = {
  "component---src-pages-home-page-jsx": () => import("./../../../src/pages/HomePage.jsx" /* webpackChunkName: "component---src-pages-home-page-jsx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

